/* the text below is for the overall description of all rooms. Each id is one paragraph */
export const roomsMainText = [ 
	{
		id: 0,
		category: 'rooms',
		name: 'Rooms Description',
		text: 'Hotel Junior Mint offers three room types designed to meet the needs of solo travelers, couples, and groups of friends or families. Guests can choose between an apartment, double rooms, and twin rooms, each thoughtfully equipped with amenities to ensure a comfortable and enjoyable stay.',
		textJ: 'ホテルジュニアミントでは、一人旅、カップル、友人や家族連れのニーズに応える3種類の客室をご用意しております。お客様はアパートメント、ダブルルーム、またはツインルームからお選びいただけます。どの客室も、快適で充実した滞在をお楽しみいただけるよう、各種アメニティを完備しています。',
		textCh1: '酒店Junior Mint提供三种房型，以满足个人、情侣、朋友和家庭的不同需求。客人可以选择公寓、双人房或双床房。每种房型都配备了多种设施，确保为您提供舒适的入住体验。',
		textCh2: '酒店Junior Mint提供三種房型，以滿足個人、情侶、朋友和家庭的不同需求。客人可以選擇公寓、雙人房或雙床房。每種房型都配備了多種設施，確保為您提供舒適的入住體驗。'
	},
	{
		id: 1,
		category: 'rooms',
		name: 'Amenities',
		text: 'The office-grade WiFi system provides coverage in all guest rooms as well as public areas. Additionally, all toilets in the property are equipped with electronic bidet functionality and heatable seats. Each guest room is furnished with an internet-enabled TV set, allowing guests to stream their favorite shows.',
		textJ: 'オフィスグレードのWiFiシステムは全てのゲストルームと公共エリアをカバーしています。物件内の全てのトイレには暖房可能なウォシュレットが備わっています。全てのゲストルームにはインターネット対応のテレビがあり、ゲストはお好きな番組をストリーミングできます。',
		textCh1: '办公室级别的WiFi系统覆盖所有客房和公共区域。物业内所有的厕所都配备了可以加热的暖水清洗座椅。所有客房都配备了可连接互联网的电视，让客人可以观看他们喜爱的节目。',
		textCh2: '辦公室級別的WiFi系統覆蓋所有客房和公共區域。物業內所有的廁所都配備了可以加熱的暖水清洗座椅。所有客房都配備了可連接互聯網的電視，讓客人可以觀看他們喜愛的節目。'
	},
	{
		id: 2,
		category: 'rooms',
		name: 'Amenities',
		text: 'Every guest room, with the exception of the Japanese Style Group Room, is equipped with a private bathroom complete with a bathtub, shower, and toilet. Additionally, each guest room is furnished with essential amenities such as an electric kettle, a hair dryer, a television, and a refrigerator. ',
		textJ: 'すべての客室は、日本式グループルームを除いて、バスタブ、シャワー、トイレを備えた専用バスルームが完備されています。さらに、各客室には電気ポット、ドライヤー、テレビ、冷蔵庫などの必需品が完備されています。',
		textCh1: '除了日式风格团体房之外，每个客房都配备有带浴缸、淋浴和卫生间的私人浴室。此外，每个客房还设有电热水壶、吹风机、电视和冰箱等基本设施。',
		textCh2: '除了日式風格團體房之外，每個客房都配備有帶浴缸、淋浴和衛生間的私人浴室。此外，每個客房還設有電熱水壺、吹風機、電視和冰箱等基本設施。'
	},
	{
		id: 3,
		category: 'rooms',
		name: 'Amenities',
		text: 'Guests at Hotel Junior Mint are welcome to enjoy all the amenities and services available at Hotel Sejour Mint. These include a traditional Japanese-style bath (ofuro) for both men and women, as well as access to the restaurant and bar facilities. ',
		textJ: 'ジュニアミントホテルにご宿泊のお客様は、隣接するセジュールミントホテルの全てのサービスもご利用いただけます。こちらには、男性用・女性用の日本風の大浴場（お風呂）のほか、レストランやバーの施設も含まれています。',
		textCh1: '入住“Junior Mint 酒店”的客人还可以享受“Sejour Mint 酒店”提供的所有服务，包括男女分开的日式浴池（ofuro），以及餐厅和酒吧服务。',
		textCh2: '入住“Junior Mint 酒店”的客人还可以享受“Sejour Mint 酒店”提供的所有服務，包括男女分開的日式浴池（ofuro），以及餐廳和酒吧服務。'
	}
]